<div class="rendition-delete-container">
  <div class="icon-container">
    <qr-icon [name]="ICON_WARNING" [color]="ICON_COLOR_WHITE"></qr-icon>
  </div>
  <p>
    ¿Está seguro que desea borrar todos los movimientos para volver a
    <b> generarlos automáticamente</b>?
  </p>
</div>
